// src/sectors/pilates/members/modal/detail/utils/memberDetailUtils.js

export function debtTry(m) {
  if (typeof m?.debtTry === 'number') return Math.max(0, m.debtTry);
  if (typeof m?.balanceCents === 'number') return Math.max(0, Math.round(m.balanceCents / 100));
  return 0;
}

export function statusLabel(m) {
  const ms = String(m?.membershipStatus || '').toUpperCase();
  if (ms === 'FROZEN') return 'Donduruldu';
  if (ms === 'PASSIVE') return 'Pasif';
  if (ms === 'ACTIVE') return 'Aktif';
  if (typeof m?.active === 'boolean') return m.active ? 'Aktif' : 'Pasif';
  return '—';
}

export function moneyTryFromCents(cents) {
  const n = Number(cents ?? 0);
  if (!Number.isFinite(n)) return '0 ₺';
  return `${Math.max(0, Math.round(n / 100))} ₺`;
}

export function dateTR(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${dd}.${mm}.${yy} ${hh}:${mi}`;
}

export function payMethodLabel(m) {
  const v = String(m || '').toUpperCase();
  if (v === 'CASH') return 'Nakit';
  if (v === 'CARD') return 'Kart';
  if (v === 'TRANSFER' || v === 'EFT' || v === 'HAVALE') return 'Havale/EFT';
  if (v === 'POS') return 'POS';
  return v || '—';
}

export function normalizePayments(res) {
  if (Array.isArray(res)) return res;
  if (res && Array.isArray(res.items)) return res.items;
  if (res && Array.isArray(res.content)) return res.content;
  return [];
}

export function memberDisplayName(member) {
  return (
    member?.fullName ||
    `${member?.name || ''} ${member?.surname || ''}`.trim() ||
    `#${member?.id ?? ''}`
  );
}

export function statusToneByLabel(st) {
  return st === 'Aktif'
    ? 'rgba(76,175,80,.18)'
    : st === 'Donduruldu'
    ? 'rgba(79,195,247,.20)'
    : 'rgba(244,67,54,.14)';
}
